export const DEFAULT_FILTERS = {
  gender: null,
  purpose: null,
  interests: [],
  ageRange: { min: 18, max: 80 },
  distanceRange: { min: 0, max: 100 },
  city: ''
};

export const normalizeFilters = (filters = {}) => ({
  ...DEFAULT_FILTERS,
  ...filters,
  interests: Array.isArray(filters?.interests) ? filters.interests : [],
  ageRange: {
    min: Number(filters?.ageRange?.min ?? DEFAULT_FILTERS.ageRange.min),
    max: Number(filters?.ageRange?.max ?? DEFAULT_FILTERS.ageRange.max)
  },
  distanceRange: {
    min: Number(filters?.distanceRange?.min ?? DEFAULT_FILTERS.distanceRange.min),
    max: Number(filters?.distanceRange?.max ?? DEFAULT_FILTERS.distanceRange.max)
  },
  city: typeof filters?.city === 'string' ? filters.city : DEFAULT_FILTERS.city
});

export const resolveMeetFilters = (profile = null, localFilters = null) => {
  const profileFilters = profile?.filters || {};

  if (localFilters) {
    return normalizeFilters({
      ...localFilters
    });
  }

  return normalizeFilters({
    ...profileFilters,
    purpose: profileFilters.purpose ?? profile?.purpose ?? DEFAULT_FILTERS.purpose,
    interests:
      Array.isArray(profileFilters.interests) && profileFilters.interests.length > 0
        ? profileFilters.interests
        : profile?.interests || DEFAULT_FILTERS.interests,
    ageRange: profileFilters.ageRange ?? profile?.preferences?.ageRange ?? DEFAULT_FILTERS.ageRange,
    distanceRange: profileFilters.distanceRange ?? {
      min: DEFAULT_FILTERS.distanceRange.min,
      max: profile?.preferences?.distance ?? DEFAULT_FILTERS.distanceRange.max
    },
    city: typeof profileFilters.city === 'string' ? profileFilters.city : DEFAULT_FILTERS.city
  });
};

export const saveFiltersToLocalStorage = (filters) => {
  try {
    const normalizedFilters = normalizeFilters(filters);
    localStorage.setItem('userFilters', JSON.stringify(normalizedFilters));
    console.log('Filters saved to localStorage:', normalizedFilters);
  } catch (error) {
    console.error('Error saving filters to localStorage:', error);
  }
};

export const loadFiltersFromLocalStorage = () => {
  try {
    const savedFilters = localStorage.getItem('userFilters');
    const parsedFilters = normalizeFilters(JSON.parse(savedFilters));
    console.log('Filters loaded from localStorage:', parsedFilters);
    return parsedFilters;
  } catch (error) {
    console.error('Error loading filters from localStorage:', error);
  }
  return null;
};

export const getActiveFiltersCount = () => {
  const localFilters = loadFiltersFromLocalStorage();
  if (!localFilters) return 0;

  let count = 0;
  if (localFilters.gender && localFilters.gender !== 'all') count++;
  if (localFilters.purpose) count++;
  if (localFilters.interests.length > 0) count++;
  if (
    localFilters.ageRange.min !== DEFAULT_FILTERS.ageRange.min ||
    localFilters.ageRange.max !== DEFAULT_FILTERS.ageRange.max
  ) {
    count++;
  }
  if (
    localFilters.distanceRange.min !== DEFAULT_FILTERS.distanceRange.min ||
    localFilters.distanceRange.max !== DEFAULT_FILTERS.distanceRange.max
  ) {
    count++;
  }
  if (localFilters.city.trim()) count++;

  return count;
};
